import { useEffect } from "react";

// Upserts <meta name="robots"> for the lifetime of the mounted component and
// restores whatever was there before on unmount, so navigating away to a
// normal indexable page never inherits the noindex directive. Used by the
// Studio Admin surface (RequireAdmin.jsx) and by "not found" states for
// invalid dynamic routes (insights/case-studies/industries/careers/the
// catch-all 404), which render an HTTP 200 SPA shell but must not be
// crawlable as if they were real content — see
// docs/decisions/006-seo-analytics-and-indexing.md.
export default function useNoIndex(content = "noindex, nofollow") {
    useEffect(() => {
        let el = document.querySelector('meta[name="robots"]');
        const created = !el;
        if (!el) {
            el = document.createElement("meta");
            el.setAttribute("name", "robots");
            document.head.appendChild(el);
        }
        const previous = el.getAttribute("content");
        el.setAttribute("content", content);
        return () => {
            if (created) {
                el.remove();
            } else if (previous !== null) {
                el.setAttribute("content", previous);
            } else {
                el.removeAttribute("content");
            }
        };
    }, [content]);
}
